export const MoreIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="5" r="1" fill="currentColor" />
    <circle cx="12" cy="12" r="1" fill="currentColor" />
    <circle cx="12" cy="19" r="1" fill="currentColor" />
  </svg>
);

export const NoDataFound = () => (
  <div className="flex flex-col items-center justify-center h-full gap-2 py-6">
    <div className="w-10 h-10 rounded-full border-2 border-blue-200 flex items-center justify-center">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#93c5fd" strokeWidth="2">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
    </div>
    <span className="text-gray-400 text-sm font-medium">No Data Found</span>
  </div>
);

export const MetricCard = ({ title, value = "0 s" }) => (
  <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 flex flex-col relative">
    <div className="flex justify-between items-start mb-1">
      <span className="text-xs text-gray-500 font-medium leading-tight pr-4">{title}</span>
      <button className="text-gray-400 hover:text-gray-600 mt-0.5 flex-shrink-0">
        <MoreIcon />
      </button>
    </div>
    <div className="flex items-center justify-center flex-1 py-4">
      <span className="text-5xl font-light text-gray-800 tracking-tight">{value}</span>
    </div>
  </div>
);

// A widget-card wrapper used for the two donut chart cards (attendee / status)
export const CardHeader = ({ title }) => (
  <div className="flex justify-between items-start mb-2">
    <span className="text-xs text-gray-500 font-medium">{title}</span>
    <button className="text-gray-400 hover:text-gray-600">
      <MoreIcon />
    </button>
  </div>
);
